import React from 'react'
import { NavLink } from 'react-router-dom'
import axios from "axios";
import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react"
import Loader from "../components/Loader";
import * as Constants from './Constants';
import {motion, AnimatePresence} from 'framer-motion'
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const { register, handleSubmit, reset } = useForm(); 


    
    useEffect(() => {    
    axios.get(`${Constants.LARAVEL_API_URL}/categories`).then(res => {
        if (res.data.status === 200) {
            setLoading(false);
            setCategories(res.data.categories);
        }
        }).catch();
    }, []);

    const modalRef = useRef()

  const onSubmit = async (data) => {
    await axios.post(`${Constants.LARAVEL_API_URL}/setOrder`, data)
    .then(response => {
        if(response.data.status === 200){
          toast.success('Ваша заявка успешно отправлена!');

          reset();
          
          window.setTimeout(function () {
            modalRef.current.close();
          }, 2000);
          
        }
    })
    .catch(function (error) {
        toast.error('Заявка не отправлена!');
    });
  };
    
  return (
    <footer>
        <Modal ref={modalRef}>
          <h2>Оставьте заявку</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset className="inputField">
                    <i className="fa-solid fa-user"></i>
                    <input                        
                        required
                        className="modalInput"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Ваше имя"
                        autoComplete='off'
                        {...register("name")}
                    />
                </fieldset>                    
                <fieldset className="inputField">
                    <i className="fa-solid fa-phone-volume"></i>
                    <input
                        required
                        className="modalInput"
                        type="phone"
                        id="phone"
                        name="phone"
                        autoComplete='off'
                        placeholder="Ваш телефон"
                        {...register("phone")}
                    />
                </fieldset>
                <button type="submit" className="modalInputBtn">Отправить</button>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div 
                    className='modalClose'
                    onClick={() => {modalRef.current.close();}}
                >x</div>
            </form> 
        </Modal>
            <div className="container">
                <div className="footer">
                    <div className="footerCategoryWrap">
                        <h3>Категории продукции</h3>
                        <ul>
                            {loading ? <Loader width={122} height={122} /> :categories.map((category) => (
                                <li key={category.id}>
                                    <NavLink to={`/catalog/${category.slug}`} props={category.name}>{category.name}</NavLink>
                                </li>
                            ))}
                        </ul>
                        <h3>Информация</h3>
                        <ul>
                            <li>
                                <NavLink 
                                to="/license"
                                className=""
                                >Лицензии и сертификаты</NavLink>
                            </li>
                            <li>
                                <NavLink 
                                to="/about"
                                className=""
                                >О нас</NavLink>
                            </li>
                            <li>
                                <NavLink 
                                to="/contacts"
                                className=""
                                >Контакты</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="footerLogoWrap">
                        <div className="footerLogo">
                            <NavLink to="/">
                                <img
                                src="/uploads/images/footerLogo.png"
                                width={266}
                                height={52}
                                alt="Оптические технологии"
                                />
                            </NavLink><br />
                            <p>Оптические технологии</p>
                        </div>
                        <div className="footerSocial">
                            <a href="https://www.linkedin.com/company/optech-2011/" target='_blank' rel="noreferrer"><i className="fab fa-linkedin"></i></a>
                            <a href="https://facebook.com" target='_blank' rel="noreferrer"><i className="fab fa-facebook"></i></a>
                            <a href="https://www.instagram.com/optech.kz/" target='_blank' rel="noreferrer"><i className="fab fa-instagram-square"></i></a>
                            <a href="https://www.youtube.com/@optechkz" target='_blank' rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        </div>
                    </div>
                    <div className="footerContactsWrap">
                        <h3>контакты</h3>
                        <div className="footerContactItem">
                            <a href="tel:+77717595949"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (771) 759-59-49 </a>
                        </div>
                        <div className="footerContactItem">
                            <a href="tel:+77272902098"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (727) 290 20 98</a>
                        </div>
                        <div className="footerContactItem">
                            <a href="mailto:info@optech.kz"><i className="fas fa-envelope" aria-hidden="true"></i>info@optech.kz</a>
                        </div>
                        <div className="footerContactItem">
                            <p><i class="fas fa-clock"></i>Пн - Пт: 09:00 AM - 18:00</p>
                        </div>
                        <div className="footerContactItem">
                            <a href="https://go.2gis.com/aml96" target="_blank" rel="noreferrer"><i className="fas fa-map-marker-alt"></i>г. Алматы, ул. Кенесары хана, <br/>дом 83/1, 1 этаж, офис 1Б</a>
                        </div>
                        <div
                            className="footerBtn"
                            onClick={() => modalRef.current.open()}
                        >оставить <br />заявку
                        </div>
                    </div>
                </div>
                <div className="copyrightWrap">
                    <div className="footerCopyYear">2024</div>
                    <div className="footerCopyright">COPYRIGHT © ВСЕ ПРАВА ЗАЩИЩЕНЫ Интернет каталог - ТОО “Оптические технологии” - <NavLink href="/">https://optech.kz</NavLink></div>
                </div>
            </div>
        </footer>
  )

}

export default Footer

const Modal = forwardRef(( props, ref ) => {  
    const [openModal, setOpenModal] = useState(false);

    useImperativeHandle(ref, () => {
      return{
        open: () => setOpenModal(true),
        close: () => setOpenModal(false)
      }
    })

    return (
      <AnimatePresence>
        {openModal && (
              <>
              <motion.div 
                  initial={{
                      opacity:0,
                  }}
                  animate={{
                      opacity:1,
                      transition:{
                          duration:0.3,
                      }
                  }}
                  exit={{
                      opacity:0,
                      transition:{
                          delay:0.3,
                      },
                  }}
                  onClick={() => setOpenModal(false)}
                  className='modal-backdrop' 
              />
              <motion.div 
                  initial={{
                      scale:0,
                  }}
                  animate={{
                      scale:1,
                      transition:{
                          duration:0.3,
                      },
                  }}
                  exit={{
                      scale:0,
                      transition:{
                          delay:0.3,
                      },
                  }}
                  className='modal-content-wrapper'
              >
                  <motion.div 
                      initial={{
                          x:100,
                          opacity:0,
                      }}
                      animate={{
                          x:0,
                          opacity:1,
                          transition:{
                              delay:0.3,
                              duration:0.3,
                          },
                      }}
                      exit={{
                          x:100,
                          opacity:0,
                          transition:{
                              duration:0.3,
                          },
                      }}
                      className='modal-content'
                  >
                      {props.children}
                  </motion.div>
              </motion.div>
          </>
          )}
      </AnimatePresence>
    )
  }
);

